module.exports = __webpack_public_path__ + "static/media/scape_back_logo.021c6af4.png";